<template>
  <ModalContainer
    class="save-view-modal"
    :title="t('dataGrid.views.saveAsNewView')"
    icon="FloppyDisk"
    :open="open"
    :primary-button="primaryButtonArgs"
    :cancel-button-text="t('common.cancel')"
    :data-qa="dataGridViewsDataQa.modalTitle"
    :data-qa-cancel-button="dataGridViewsDataQa.cancelBtn"
    :data-qa-primary-button="dataGridViewsDataQa.saveAsNewBtn"
    :data-qa-close="dataGridViewsDataQa.closeIcon"
    @on-close="handleClose"
    @primary-button-click="handleSave"
  >
    <div class="save-view-modal-content">
      <TextInput
        v-model="name"
        :label="t('dataGrid.views.modal.nameLabel')"
        :validator="validateName"
        :error-text="nameErrorText"
        :data-qa="dataGridViewsDataQa.nameInput"
        :data-qa-label="dataGridViewsDataQa.nameLabel"
        @update:model-value="onNameInput"
      />
      <CheckboxItem
        v-model:checked="setAsDefault"
        :text="t('dataGrid.views.modal.setAsDefault')"
        value="setAsDefault"
        :disabled="true"
        :required="false"
        :data-qa="dataGridViewsDataQa.setDefaultCheckbox"
      />
    </div>
  </ModalContainer>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { CheckboxItem, ModalContainer, TextInput } from '@lw-design-system/ui';
import { useViewNameValidation } from '@/composables/common/data-grid/useViewNameValidation';
import { dataGridViewsDataQa } from '~/constants/commons/data-qa';

const { t } = useI18n();

const props = defineProps<{ open: boolean; serverDuplicateError: boolean }>();
const emit = defineEmits<{
  (e: 'on-close'): void;
  (e: 'save', name: string): void;
  (e: 'clear-server-duplicate-error'): void;
}>();

const { name, setAsDefault, trimmedName, validateName, nameErrorText, canSave, primaryButtonArgs } =
  useViewNameValidation(toRef(props, 'serverDuplicateError'));

const onNameInput = () => {
  if (props.serverDuplicateError) emit('clear-server-duplicate-error');
};

const handleClose = () => emit('on-close');

const handleSave = () => {
  if (!canSave.value) return;
  emit('save', trimmedName.value);
};
</script>

<style scoped>
.save-view-modal-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
